export default __webpack_public_path__ + "static/media/supply-gear-icons-black.3ca03f3e.svg";